import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Head, Loader, Nav, Social, Email, Footer } from '@components';

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const PageTransitionWrapper = styled.div`
  .page-enter {
    opacity: 0;
    transform: translateY(20px);
  }
  .page-enter-active {
    opacity: 1;
    transform: translateY(0);
    transition:
      opacity 300ms ease-out,
      transform 300ms ease-out;
  }
  .page-exit {
    opacity: 1;
    transform: translateY(0);
  }
  .page-exit-active {
    opacity: 0;
    transform: translateY(-20px);
    transition:
      opacity 300ms ease-in,
      transform 300ms ease-in;
  }
`;

const Layout = ({ children, location }) => {
  const isHome = location?.pathname === '/';
  const [isLoading, setIsLoading] = useState(isHome);

  useEffect(() => {
    document.querySelectorAll('a').forEach(link => {
      if (link.host !== window.location.host) {
        link.setAttribute('rel', 'noopener noreferrer');
        link.setAttribute('target', '_blank');
      }
    });
  }, []);

  return (
    <>
      <Head />
      <a className="skip-to-content" href="#content">
        Skip to Content
      </a>

      {isLoading && isHome ? (
        <Loader finishLoading={() => setIsLoading(false)} />
      ) : (
        <StyledContent>
          <Nav isHome={isHome} />
          <Social isHome={isHome} />
          <Email isHome={isHome} />

          <PageTransitionWrapper>
            <TransitionGroup component={null}>
              <CSSTransition key={location?.pathname || '/'} classNames="page" timeout={300}>
                <main id="content">{children}</main>
              </CSSTransition>
            </TransitionGroup>
          </PageTransitionWrapper>

          <Footer />
        </StyledContent>
      )}
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object,
};

export default Layout;
